import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.extend(updateLocale);
dayjs.extend(relativeTime);

dayjs.updateLocale("en", {
	formats: {
		// Japan format options localization
		LTS: "h:mm:ss A",
		LT: "h:mm A",
		L: "YYYY/MM/DD",
		LL: "YYYY, MMMM D",
		LLL: "YYYY, MMMM D, h:mm A",
		LLLL: "dddd, MMMM D, YYYY h:mm A",
		// lowercase/short, optional formats for localization
		l: "YYYY/M/D",
		ll: "YYYY, MMMM D",
		lll: "YYYY, MMMM D, h:mm A",
		llll: "ddd, MMMM D, YYYY h:mm A",
	},
});

export const dayjsLocal = dayjs().tz("Asia/Tokyo");
